import React from 'react';
import '../App.css';
import $ from 'jquery';
import config from '.././config.json';
import moment from 'moment';
import '../AdditionalDates';

import {
    Form, Input, Select,
    DatePicker, InputNumber, Spin, notification, Modal
} from 'antd';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';
import { responsiveArray } from 'antd/lib/_util/responsiveObserve';

const FormItem = Form.Item;
const Option = Select.Option;


class AddClassForm extends React.Component {

    formVariables = [{ Name: '' }, { Category: '' }, { IsIndefinite: '' }, { System: '' }, { Type: '' }, { StartDate: '' }, { AdditionalDates: '' }, { AvailableDate: '' }, { EndDate: '' }, { StartTime: '' }, { EndTime: '' }, { Location: '' }, { Venue: '' }, { VenueURL: '' },
    { Address: '' }, { Cost: '' }, { PaymentURL: '' }, { Capacity: '' }, { OnlineCapacity: '' }, { City: '' }, { Waitlist: '0' }, { Comments: '' }, { ClassMode: '' }];

    constructor(props) {
        super(props);
        //Set the form variables
        this.props.form.validateFieldsAndScroll((err, values) => {
            this.formVariables.Name = values.name;
            this.formVariables.Category = values.category;
            this.formVariables.IsIndefinite = values.indef;
            this.formVariables.System = values.system;
            this.formVariables.Type = values.type;
            this.formVariables.StartDate = values.startDate;
            this.formVariables.AdditionalDates = values.additionalDates;
            this.formVariables.EndDate = values.endDate;
            this.formVariables.StartTime = moment('8:00 am', 'h:mm a');
            this.formVariables.EndTime = moment('5:00 pm', 'h:mm a');
            this.formVariables.Venue = values.venue;
            this.formVariables.VenueURL = values.venueURL;
            this.formVariables.Address = values.address;
            this.formVariables.Cost = values.cost;
            this.formVariables.PaymentURL = values.paymentURL;
            this.formVariables.MeetingURL = values.meetingURL;
            this.formVariables.Capacity = values.capacity;
            this.formVariables.City = values.city;
            this.formVariables.Waitlist = 0;
            this.formVariables.Comments = values.comments;
            this.formVariables.AvailableDate = values.availableDate;
            this.formVariables.ClassMode = values.classMode;
            this.formVariables.OnlineCapacity = values.onlineCapacity; // onlinecapacity is only for hybrid courses, otherwise it should be null
        });

        this.state = {
            loading: false,
            confirmDirty: false,
            autoCompleteResult: [],
            TcpSelected: false,
            CRSelected: false,
            categoriesData: [],
            systemData: [],
            typeData: [],
            login: true,
            addDateRows: [],
            startDateEndTime: "",
            endDateStartTime: "",
            classModeData: [],
            HybridSelected: false,
            classNameData: [],
            duplicate: false,
            indef: false
        };

    }



    /**
     * This code runs after a component is rendered.
     * As a result this is where we retrieve our data from the server.
     */
    componentDidMount() {

        LoginForm.ValidateServerToken(() => { this.setState({ login: false }) });

        this.populateDropDowns();

        //For editing classes
        if (this.props.updateFields) {

            //console.log(this.props.updateFields); 

            this.autoFillFormVariablesWithUpdateFields();


            this.addDateRange();
            //Set fields specific to TCP visible 
            if (this.props.updateFields.SystemName.toString() === 'TCP') {
                this.setState({
                    TcpSelected: true
                });
            } else {
                this.setState({
                    TcpSelected: false
                });
            }
            if (this.props.updateFields.IsIndefinite.toString() === 'Indefinite') {
                this.setState({
                    indef: true
                });
            } else {
                this.setState({
                    indef: false
                });
            }
            if (this.props.updateFields.SystemName.toString() === 'External Civil Rights Training') {
                this.setState({
                    CRSelected: true
                });
            } else {
                this.setState({
                    CRSelected: false
                });
            }
            // show the online capacity if hybrid edit
            if (this.props.updateFields.ClassModeID === 3) {
                this.setState({
                    HybridSelected: true
                });
            } else {
                this.setState({
                    HybridSelected: false
                });
            }
        }
    }

    populateDropDowns = () => {
        // ClassName Dropdown for allowing duplication
        this.ajaxCall('POST', '/api/dropdown/getdropdown',
            { "DropdownName": "Cert_CertClass", "DropdownDataColumns": ["Name"] }, (data) => {
                this.setState({
                    classNameData: data
                });
            }, () => {
                console.log('failed to get ClassName data');
            });

        // System Dropdown
        this.ajaxCall('POST', '/api/dropdown/getdropdown',
            { "DropdownName": "Cert_ClassSystem", "DropdownDataColumns": ["SystemName"] }, (data) => {
                this.setState({
                    systemData: data
                });
            }, () => {
                console.log('failed to get ClassSystem data');
            });
        // Category Dropdown
        this.ajaxCall('POST', '/api/dropdown/getdropdown',
            { "DropdownName": "Cert_ClassCategory", "DropdownDataColumns": ["CategoryName"] }, (data) => {
                this.setState({
                    categoriesData: data
                })
            }, () => {
                console.log('failed to get ClassCategory data');
            });
        // Type Dropdown
        this.ajaxCall('POST', '/api/dropdown/getdropdown',
            { "DropdownName": "Cert_ClassType", "DropdownDataColumns": ["TypeName"] }, (data) => {
                this.setState({
                    typeData: data
                })
            }, () => {
                console.log('failed to get ClassType data');
            });
        // Class Mode Dropdown
        this.ajaxCall('POST', '/api/dropdown/getdropdown',
            { "DropdownName": "Cert_ClassMode", "DropdownDataColumns": ["ModeName"] }, (data) => {
                this.setState({
                    classModeData: data
                })
            }, () => {
                console.log('failed to get ClassMode data');
            });
    }

    autoFillFormVariablesWithUpdateFields = () => {
        this.formVariables.Name = this.props.updateFields.Name;
        this.formVariables.Category = this.props.updateFields.CategoryId.toString();
        this.formVariables.IsIndefinite = this.props.updateFields.IsIndefinite;
        this.formVariables.System = this.props.updateFields.SystemName.toString();
        this.formVariables.Type = this.props.updateFields.ClassTypeId.toString();
        this.formVariables.startDate = moment(this.props.updateFields.StartDate);
        this.formVariables.endDate = moment(this.props.updateFields.EndDate);
        this.formVariables.StartTime = moment(this.props.updateFields.StartDate);
        this.formVariables.EndTime = moment(this.props.updateFields.EndDate);
        this.formVariables.Venue = this.props.updateFields.Venue;
        this.formVariables.VenueURL = this.props.updateFields.VenueURL;
        this.formVariables.Address = this.props.updateFields.Address;
        this.formVariables.Cost = this.props.updateFields.Cost;
        this.formVariables.PaymentURL = this.props.updateFields.PaymentURL;
        this.formVariables.MeetingURL = this.props.updateFields.MeetingURL;
        this.formVariables.Capacity = this.props.updateFields.Capacity;
        this.formVariables.City = this.props.updateFields.City;
        this.formVariables.Comments = this.props.updateFields.Comments;
        this.formVariables.Waitlist = 0;
        this.formVariables.AvailableDate = moment(this.props.updateFields.AvailableDate);
        this.formVariables.ClassMode = this.props.updateFields.ClassModeID.toString();
        this.formVariables.OnlineCapacity = this.props.updateFields.OnlineCapacity; // onlinecapacity is only for hybrid courses, otherwise it should be null
    }

    autoFillFormVariablesWithDuplicateData = (data) => {
        // I commented out some fields because if they were there they would be prone to errors
        this.formVariables.Name = data.Name;
        this.formVariables.Category = data.CategoryId.toString();
        this.formVariables.IsIndefinite = data.IsIndefinite;
        this.formVariables.System = data.SystemName.toString();
        this.formVariables.Type = data.ClassTypeId.toString();
        // this.formVariables.startDate = moment(data.StartDate);
        // this.formVariables.endDate = moment(data.EndDate);
        // this.formVariables.StartTime = moment(data.StartDate);
        // this.formVariables.EndTime = moment(data.EndDate);
        this.formVariables.Venue = data.Venue;
        this.formVariables.VenueURL = data.VenueURL;
        this.formVariables.Address = data.Address;
        this.formVariables.Cost = data.Cost;
        this.formVariables.PaymentURL = data.PaymentURL;
        this.formVariables.Capacity = data.Capacity;
        this.formVariables.City = data.City;
        this.formVariables.Comments = data.Comments;
        this.formVariables.Waitlist = 0;
        // this.formVariables.AvailableDate = moment(data.AvailableDate);
        this.formVariables.ClassMode = data.ClassModeID.toString();
        this.formVariables.OnlineCapacity = data.OnlineCapacity; // onlinecapacity is only for hybrid courses, otherwise it should be null

        // can reuse this handler to show/hide hybrid visible fields
        this.handleSelectClassModeChange(data.ClassModeID.toString());
        // show/hide tcp visible fields
        if (data.SystemName === 'TCP') {
            this.setState({
                TcpSelected: true
            });
        } else {
            this.setState({
                TcpSelected: false
            });
        }
        if (data.IsIndefinite == '1') {
            this.setState({
                indef: true
            });
        } else {
            this.setState({
                indef: false
            });
        }
        if (data.SystemName === 'External Civil Rights Training') {
            this.setState({
                CRSelected: true
            });
        } else {
            this.setState({
                CRSelected: false
            });
        }
    }

    componentDidUpdate() {
        if (this.props.updateFields) {
            this.populateDateTimes();
        }
        //when add a new class
        if (!this.props.updateFields) {
            var startdate = this.props.form.getFieldValue('startDate');
            if (startdate) {
                var newDate = new Date();
                startdate = new Date(startdate);
                newDate.setDate(startdate.getDate() - 7);
                this.formVariables.AvailableDate = moment(newDate);
            }
        }
    }

    componentWillUnmount() {
        if (!this.props.updateFields) {
            window.location.hash = "/admin/admin";
        }
        else {
            window.location.hash = "/admin/editclass";
        }
    }

    /**
    * time change event
    */
    handleStartDateEndTime = (value) => {
        this.setState({ startDateEndTime: value });
    }
    handleEndDateStartTime = (value) => {
        this.setState({ endDateStartTime: value });
    }

    /**
     * form reset event
     */
    handleReset = (e) => {
        //reset fields except time selection, reverts to original class info for duplication
        this.props.form.resetFields();
        this.setState({
            startDateEndTime: undefined,
            endDateStartTime: undefined,
            TcpSelected: false,
            CRSelected: false,
            HybridSelected: false,
            indef: false
        });
    }

    handleSwitchModeButton = (e) => {
        // show fields for other mode, reset conditional visibilty fields
        this.setState({
            duplicate: !this.state.duplicate,
            TcpSelected: false,
            CRSelected: false,
            HybridSelected: false,
            indef: false
        });

        // set form vars to empty so reset fields will work
        this.formVariables = [{ Name: '' }, { Category: '' }, { IsIndefinite: '' }, { System: '' }, { Type: '' }, { StartDate: '' }, { AdditionalDates: '' }, { AvailableDate: '' }, { EndDate: '' }, { StartTime: '' }, { EndTime: '' }, { Location: '' }, { Venue: '' }, { VenueURL: '' },
        { Address: '' }, { Cost: '' }, { PaymentURL: '' }, { Capacity: '' }, { OnlineCapacity: '' }, { City: '' }, { Waitlist: '0' }, { Comments: '' }, { ClassMode: '' }];
        this.props.form.resetFields(); // sets fields to initial values, which are stored in formVariables
        // not sure why I can't set this above, but set these here so that defaults stay when mode switches.
        this.formVariables.StartTime = moment('8:00 am', 'h:mm a');
        this.formVariables.EndTime = moment('5:00 pm', 'h:mm a');

        // scroll to top
        window.scrollTo({ x: 0 }, 'smooth');
    }

    preventNulls(formObj) {
        console.log(formObj)
        if (formObj.City == null || formObj.City == "") {
            formObj.City = "N/A"
        }
        if (formObj.Address == null || formObj.Address == "") {
            formObj.Address = "N/A"
        }
        if (formObj.Cost == null || formObj.Cost == "") {
            formObj.Cost = 0
        }
        if (formObj.Capacity == null || formObj.Capacity == "") {
            formObj.Capacity = 999999
        }
        console.log(formObj)
        return formObj
    }

    /**
    * From submit event
    */
    handleSubmit = (e) => {
        //keeps the page from refreshing
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((err, values) => {
            if (values.system == "TCP") { values.system = 0 }
            else if (values.system == "ESCC") { values.system = 1 }
            else if (values.system == "External Civil Rights Training") { values.system = 2 }
            if (!err) {
                if (values.availableDate == undefined) {
                    values.availableDate = moment('8:00 am', 'h:mm a');
                }
                if (values.startDate == undefined) {
                    values.startDate = moment('8:00 am', 'h:mm a');
                }
                if (values.endDate == undefined) {
                    values.endDate = moment('8:00 am', 'h:mm a');
                }
                if (values.startTime == undefined) {
                    values.startTime = moment('8:00 am', 'h:mm a');
                }
                if (values.endTime == undefined) {
                    values.endTime = moment('5:00 pm', 'h:mm a');
                }
                console.log(values)

                //console.log("logging values: " + values);
                //Format the data to be recieved by the server
                var formObj = {
                    Name: values.name,
                    CategoryId: values.category ? values.category : "7",
                    ClassTypeId: values.type,
                    IsIndefinite: values.indef,
                    ClassSystemId: values.system,
                    StartDate: values.startDate.set({ 'hour': values.startTime.get('hour'), 'minute': values.startTime.get('minute') }).format().toString(),
                    AdditionalDates: this.concatenateDateTimes(),
                    EndDate: values.endDate.set({ 'hour': values.endTime.get('hour'), 'minute': values.endTime.get('minute') }).format().toString(),
                    Venue: values.venue,
                    VenueURL: values.venueURL,
                    Address: values.address,
                    Cost: values.cost,
                    PaymentURL: values.paymentURL,
                    Capacity: values.capacity,
                    City: values.city,
                    Waitlist: 0,
                    Comments: values.comments,
                    AvailableDate: values.availableDate.format().toString(),
                    ClassModeID: values.classMode,
                    MeetingURL: values.meetingURL,
                    OnlineCapacity: values.onlineCapacity ? values.onlineCapacity : 0 // onlinecapacity is only for hybrid courses, otherwise it should be null
                }
                formObj = this.preventNulls(formObj)
                console.log(formObj)
                //Display the loading spinner
                this.setState({ loading: true })
                if (!this.props.updateFields) {//add class

                    this.ajaxCall('POST', '/api/classes/add',
                        formObj, (data) => {//success
                            this.setState({ startDateEndTime: undefined, endDateStartTime: undefined });
                            this.props.form.setFieldsValue({
                                startDate: '',
                                endDate: ''
                            });

                            //this.openNotificationWithIcon('success', 'Success', 'Class added successfully!');
                            Modal.success({
                                title: 'Success',
                                content: "Class added successfully!",
                            });
                            window.location.hash = "/admin/admin";
                            this.setState({ loading: false });
                        }, () => {//fail
                            //this.openNotificationWithIcon('error', 'Failed To Add', 'Connection to server may have been lost!');
                            Modal.error({
                                title: 'Failed To Add',
                                content: "Connection to server may have been lost!",
                            });
                            this.setState({ loading: false });
                        });

                }
                else {//update class
                    formObj.Id = this.props.updateFields.Id;

                    this.ajaxCall('POST', '/api/classes/update',
                        formObj, (data) => {//success
                            Modal.success({
                                title: 'Successful Update',
                                content: "Please note that if Class Mode changed, you will need to edit student enrollment for that class as well.",
                            });
                            this.props.form.resetFields();
                            this.setState({ loading: false })
                            this.props.updateEvent();
                            window.location.hash = "/admin/admin";
                        }, () => {//fail
                            //this.openNotificationWithIcon('error', 'Failed To Add', 'Connection to server may have been lost!');
                            Modal.error({
                                title: 'Failed To Update',
                                content: "Connection to server may have been lost!",
                            });
                            this.setState({ loading: false });
                        });

                }
            }
            else {
                console.error(err);
            }
        });

    };
    handleBack = () => {
        this.props.form.resetFields();
        this.setState({ loading: false });
        this.props.updateEvent();
        window.location.href = '#/admin/editclass';
    }
    /**
     * Used for custom ajax calls
     * @param {any} type
     * @param {any} url
     * @param {any} data
     * @param {any} done
     * @param {any} fail
     */
    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    /**
     * Set fields specific to TCP visible
     * @param {any} value
     */
    handleSelectChangeSystem = (value) => {
        if (value === '0')
            this.setState({
                TcpSelected: true,
                CRSelected: false
            });
        else if (value == "2") {
            this.setState({
                CRSelected: true,
                TcpSelected: false
            });
        } else {
            this.setState({
                TcpSelected: false,
                CRSelected: false
            });
        }
    }
    handleSelectChangeIndef = (value) => {
        if (value == "1") {
            this.setState({
                indef: true
            })
        } else {
            this.setState({
                indef: false
            })
        }
        console.log(this.state.indef)
    }
    handleSelectClassModeChange = (value) => {
        if (value === '3')
            this.setState({
                HybridSelected: true
            });
        else
            this.setState({
                HybridSelected: false
            });
    }
    handleSelectClassNameChange = (value, optionObj) => {
        // i'm not sure why, but to get key value I found that the above parameters worked??
        this.setState({ loading: true });
        this.ajaxCall('GET', '/api/classes/getid?id=' + optionObj.key, null, (data) => {
            //set the form fieldsconsole.log(data);
            this.autoFillFormVariablesWithDuplicateData(data);
        }, (fail) => {
            Modal.error({
                title: 'Failed To Get Class Information',
                content: "Connection to server may have been lost!" + fail,
            });
        });
        this.setState({ loading: false });
    }
    /**
    * Removes a date and time row
    */
    removeDateRange = () => {
        //console.log("DELETE TIME DATE:" + JSON.stringify(this.state.addDateRows[1]));
        document.getElementById("addDT").deleteRow(2);
    }
    /**
    * Used to add dates to a table so that different start and end times can be entered for the confirmation email *
    * the while loop creates as many additional date rows in the table for the number of days that are
    * in between start and end dates. This can be quite large, and our DB currently only allows 200 chars
    * for the additional date data, hence I have limited to 10 additional date rows and each has ~ 19 chars
    * updated 09/30/2021 Elliot Thompson
    */
    addDateRange = () => {
        var newRow = {};
        var oneDayEquiv = 24 * 60 * 60 * 1000; //hr*min*sec*ms
        var startDate = new Date();
        var endDate = new Date();
        if (!this.props.updateFields) {
            startDate = new Date(this.props.form.getFieldValue('startDate'));
            endDate = new Date(this.props.form.getFieldValue('endDate'));
        }

        else {
            startDate = new Date(this.props.updateFields.StartDate);
            endDate = new Date(this.props.updateFields.EndDate);
        }

        var numDays = Math.round(Math.abs((startDate.getTime() - endDate.getTime()) / (oneDayEquiv)));
        console.log(numDays);
        var count = 0;
        // come here and edit count < 10 to change # add'l rows.
        while (count < numDays - 1 && count < 10) {
            this.state.addDateRows = this.state.addDateRows.concat(newRow);
            count++;
        }

        this.setState({
            addDateRows: this.state.addDateRows
        });

    }


    /**
    * Used to populate the date/time values from additional dates string.
    */
    populateDateTimes = () => {
        if (this.state.CRSelected && this.state.indef) { return; }
        var addDTTbl = document.getElementById('addDT');
        var dtList = this.props.updateFields.AdditionalDates;
        console.log(dtList)
        if (dtList != "") {
            var arrDTList = dtList.split('\n');
            for (var rw = 0, rwTot = addDTTbl.rows.length - 2; rw < rwTot; rw++) {
                if (arrDTList[rw] != "" && arrDTList[rw] != null) {
                    var splitDay = arrDTList[rw].split('&'); //first element is the date, second is the time range

                    if (splitDay[0] != "" && splitDay.length > 1) {
                        var splitTimes = splitDay[1].split('_'); //time range from splitDay
                        if (rw === 0) { // first day
                            var sdet = splitTimes[1];
                            var dvSDET = document.getElementById('sdet');
                            var stEndTimes = dvSDET.getElementsByTagName('input');
                            var stEndTime = stEndTimes[0];
                            stEndTime.value = sdet;

                        }
                        else {
                            if (rw === addDTTbl.rows.length - 2) { // last day
                                var edst = splitTimes[0];
                                var dvEDST = document.getElementById('edst');
                                var enStartTimes = dvEDST.getElementsByTagName('input');
                                var enStartTime = enStartTimes[0];
                                enStartTime.value = edst;
                            }
                            else {
                                // now for the rest of the dates
                                var midDateInput = addDTTbl.rows[rw + 1].cells[1].getElementsByTagName('input');
                                var midStartInput = addDTTbl.rows[rw + 1].cells[2].getElementsByTagName('input');
                                var midEndInput = addDTTbl.rows[rw + 1].cells[3].getElementsByTagName('input');

                                var midDate = splitDay[0];
                                var midStartTime = splitTimes[0];
                                var midEndTime = splitTimes[1];

                                midDateInput[0].value = midDate;
                                midStartInput[0].value = midStartTime;
                                midEndInput[0].value = midEndTime;
                            }
                        }
                    }
                }
            }
        }
    }


    /**
    * Used to concatenate the values from the date/time fields for the confirmation email
    */
    concatenateDateTimes = () => {
        if (this.state.CRSelected && this.state.indef) { return new Date(); }
        var addDTTbl = document.getElementById('addDT');
        var startDate = new Date(this.props.form.getFieldValue('startDate'));
        var sDay = startDate.getDate();
        var sMonth = startDate.getMonth() + 1;
        var sYear = startDate.getFullYear();

        if (sDay < 10) {
            sDay = '0' + sDay;
        }

        if (sMonth < 10) {
            sMonth = '0' + sMonth;
        }

        var sDateStr = sMonth + '-' + sDay + '-' + sYear;

        var startTime = new Date(this.props.form.getFieldValue('startTime'));
        startDate.setTime = startTime.getTime();

        // time values
        var hr = startTime.getHours();
        var min = startTime.getMinutes();
        var suf = '';

        if (hr > 6 && hr < 12) {
            suf = 'am';
        } else {
            suf = 'pm';
        }

        if (min < 10) {
            min = '0' + min;
        }
        if (hr > 12) {
            hr = hr - 12;
        }
        var startTimeStr = hr + ':' + min + ' ' + suf;
        var dvSDET = document.getElementById('sdet');
        var stEndTime = dvSDET.getElementsByTagName('input');
        var sdetValue = stEndTime[0].value.toString();
        var concat = sDateStr + '&' + startTimeStr + '_' + sdetValue + '\n';
        //for each row in add date table (skipping what??), concatenate the columns of each row with specific format
        for (var rw = 2, totR = addDTTbl.rows.length; rw < totR - 1; rw++) {
            for (var col = 1, totC = addDTTbl.rows[rw].cells.length; col < totC; col++) {
                var inADT = addDTTbl.rows[rw].cells[col].getElementsByTagName('input');
                var adtValue = inADT[0];
                if (adtValue.value != null) {
                    concat = concat + adtValue.value;
                    if (col == 1) {
                        concat = concat + '&';
                    }
                    else {
                        if (col == 2) {
                            concat = concat + '_';
                        } else {
                            concat = concat + '\n';
                        }
                    }
                }
            }
        }

        var endDate = new Date(this.props.form.getFieldValue('endDate'));
        var eDay = endDate.getDate();
        var eMonth = endDate.getMonth() + 1;
        var eYear = endDate.getFullYear();

        if (eDay < 10) {
            eDay = '0' + eDay;
        }

        if (eMonth < 10) {
            eMonth = '0' + eMonth;
        }

        var eDateStr = eMonth + '-' + eDay + '-' + eYear;

        var dvEDST = document.getElementById('edst');
        var enStartTime = dvEDST.getElementsByTagName('input');

        var edst = enStartTime[0].value.toString();
        var endTime = new Date(this.props.form.getFieldValue('endTime'));

        var hr = endTime.getHours();
        var min = endTime.getMinutes();
        var suf = '';

        if (hr > 6 && hr < 12) {
            suf = 'am';
        } else {
            suf = 'pm';
        }

        if (min < 10) {
            min = '0' + min;
        }

        if (hr > 12) {
            hr = hr - 12;
        }

        var endTimeStr = hr + ':' + min + ' ' + suf;

        concat = concat + eDateStr + '&' + edst + '_' + endTimeStr + '\n';
        return concat;
    }

    /**
    * Used to display notifications
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };


    endDateValid = (rule, value, callback) => {
        const form = this.props.form;
        if (this.props.form.getFieldValue('startDate').get('date') < form.getFieldValue('endDate').get('date')) {
            callback();
        }
        else {
            if (form.getFieldValue('startTime').get('hour') < form.getFieldValue('endTime').get('hour')) {
                callback();
            } else if (form.getFieldValue('startTime').get('minute') < form.getFieldValue('endTime').get('minute')) {
                callback();
            } else {
                callback('End date should be after start date!');
            }

        }
    }


    /**
     * Render functions
     */
    render() {
        const { startDateEndTime } = this.state;
        const { endDateStartTime } = this.state;
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };
        var switchModeTitle = (!this.props.updateFields && !this.state.duplicate) ? "Or Switch to Duplicate" : "Or Switch to Add";
        return (
            <div>{
                this.state.login ?
                    <Spin spinning={this.state.loading}>
                        {(!this.props.updateFields && !this.state.duplicate &&
                            <h2>Add Class
                                <button type="button" className="btn btn-default"
                                    onClick={(e) => { this.handleSwitchModeButton(e); }}
                                    style={{ margin: 15 }}>
                                    {switchModeTitle}
                                </button>
                            </h2>) ||
                            (!this.props.updateFields && this.state.duplicate &&
                                <h2>Duplicate Class
                                    <button type="button" className="btn btn-default"
                                        onClick={(e) => { this.handleSwitchModeButton(e); }}
                                        style={{ margin: 15 }}>
                                        {switchModeTitle}
                                    </button>
                                </h2>)

                        }
                        {this.props.updateFields && <h2>Edit Class</h2>}
                        <hr />
                        <Form onSubmit={this.handleSubmit}>
                            {this.state.duplicate &&
                                <FormItem {...formItemLayout} label="Class Name Select" >
                                    {getFieldDecorator('nameSelect', {
                                        initialValue: this.formVariables.Name,
                                        rules: [{
                                            required: true, message: 'Please select a class name!',
                                        }],
                                    })(
                                        <Select
                                            placeholder="Choose Class to Duplicate"
                                            onChange={(value, optionObj) => { this.handleSelectClassNameChange(value, optionObj) }}
                                        >
                                            {this.state.classNameData.map(a =>
                                                <Option key={a.Id} value={a.AdditionalValues[0]} >{a.AdditionalValues[0]}</Option>
                                            )}
                                        </Select>
                                    )
                                    }
                                </FormItem>
                            }
                            <FormItem {...formItemLayout} label="Class Name" >
                                {getFieldDecorator('name', {
                                    initialValue: this.formVariables.Name,
                                    rules: [{
                                        required: true, message: 'Please input the class name!',
                                    }],
                                })(
                                    <Input />
                                )
                                }
                            </FormItem>
                            <FormItem
                                label="System"
                                {...formItemLayout}>
                                {getFieldDecorator('system', {
                                    initialValue: this.formVariables.System,
                                    rules: [{ required: true, message: 'Please select a system!' }],
                                })(
                                    <Select
                                        placeholder="System"
                                        onChange={this.handleSelectChangeSystem}>
                                        {this.state.systemData.map(a => <Option key={a.Id}>{a.AdditionalValues[0]}</Option>)}
                                    </Select>
                                )}
                            </FormItem>
                            {this.state.CRSelected && <FormItem
                                label="Class Type"
                                {...formItemLayout}>
                                {getFieldDecorator('indef', {
                                    initialValue: this.formVariables.IsIndefinite,
                                })(
                                    <Select onChange={this.handleSelectChangeIndef}>
                                        <Option key='0'>Regular</Option>
                                        <Option key='1'>Indefinite</Option>
                                    </Select>
                                )}</FormItem>}
                            {this.state.TcpSelected && <FormItem
                                label="Category"
                                {...formItemLayout}>
                                {getFieldDecorator('category', {
                                    initialValue: this.formVariables.Category,
                                    rules: [{ required: true, message: 'Please select a category!' }],
                                })(
                                    <Select
                                        placeholder="Class category."
                                        onChange={this.handleSelectChangeCategory}>
                                        {this.state.categoriesData.map(d => <Option key={d.Id}>{d.AdditionalValues[0]}</Option>)}
                                    </Select>
                                )}
                            </FormItem>}
                            {this.state.TcpSelected && <FormItem
                                label="Type"
                                {...formItemLayout}>
                                {getFieldDecorator('type', {
                                    initialValue: this.formVariables.Type,
                                    rules: [{ required: true, message: 'Please select a Type!' }],
                                })(
                                    <Select
                                        placeholder="Class Type">
                                        {this.state.typeData.map(d => <Option key={d.Id}>{d.AdditionalValues[0]}</Option>)}
                                    </Select>
                                )}
                            </FormItem>}

                            {/* I removed commented out start date code from here since it is below on 10/19/2021 Elliot Thompson */}

                            {/*Insert table here*/}
                            {!(this.state.CRSelected && this.state.indef) && <FormItem
                                {...formItemLayout} label={(
                                    <span >
                                        Class Dates&nbsp;
                                    </span>
                                )}>
                                <table id="addDT" >{/*style={{ marginLeft: 25 }}>*/}
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Date</th>
                                            <th>Start Time</th>
                                            <th>End Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Start Date</td>
                                            <td>
                                                {getFieldDecorator('startDate', {
                                                    initialValue: this.formVariables.startDate,
                                                })(
                                                    <DatePicker
                                                        format="MM-DD-YYYY"
                                                        placeholder={['Start Date']} />
                                                )}
                                            </td>
                                            <td>
                                                {getFieldDecorator('startTime', {
                                                    initialValue: this.formVariables.StartTime,
                                                })(
                                                    <TimePicker use12Hours minuteStep={15} showSecond={false} format="h:mm a" />
                                                )}
                                            </td>
                                            <td >
                                                <div id="sdet" >
                                                    <TimePicker id="startDateEndTime" minuteStep={15} showSecond={false} autoComplete='off' value={this.state.startDateEndTime} onChange={this.handleStartDateEndTime} use12Hours format="h:mm a" />
                                                </div>
                                            </td>
                                        </tr>
                                        {this.state.addDateRows.map((item, idx) => (
                                            <tr key={idx}>
                                                <td></td>
                                                <td>
                                                    <DatePicker format="MM-DD-YYYY" placeholder={['Additional Date']} />
                                                </td>
                                                <td>
                                                    <TimePicker use12Hours minuteStep={15} showSecond={false} format="h:mm a" />
                                                </td>
                                                <td>
                                                    <TimePicker use12Hours minuteStep={15} showSecond={false} format="h:mm a" />
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td>End Date</td>
                                            <td>
                                                {getFieldDecorator('endDate', {
                                                    initialValue: this.formVariables.endDate,
                                                    rules: [{
                                                        validator: this.endDateValid
                                                    }],
                                                })(
                                                    <DatePicker

                                                        format="MM-DD-YYYY"
                                                        placeholder={['End Date']} />
                                                )}
                                            </td>
                                            <td>
                                                <div id="edst">
                                                    <TimePicker use12Hours minuteStep={15} value={this.state.endDateStartTime} onChange={this.handleEndDateStartTime} showSecond={false} format="h:mm a" />
                                                </div>
                                            </td>
                                            <td>
                                                {getFieldDecorator('endTime', {
                                                    initialValue: this.formVariables.EndTime,
                                                })(
                                                    <TimePicker use12Hours minuteStep={15} showSecond={false} format="h:mm a" />
                                                )}
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                                <span>
                                    <button type='button' id='btnAddDT' onClick={() => { this.addDateRange(); }}>Add More Dates and Times</button>
                                    <button type='button' id='btnRemoveDT' onClick={() => { this.removeDateRange(); }}>Delete Date and Time Row</button>
                                </span>
                            </FormItem>}

                            <FormItem
                                label="Class Mode"
                                {...formItemLayout}>
                                {getFieldDecorator('classMode', {
                                    initialValue: this.formVariables.ClassMode,
                                    rules: [{ required: true, message: 'Please select a class mode!' }],
                                })(
                                    <Select
                                        placeholder="ClassMode"
                                        onChange={this.handleSelectClassModeChange}>
                                        {this.state.classModeData.map(a => <Option key={a.Id}>{a.AdditionalValues[0]}</Option>)}
                                    </Select>
                                )}
                            </FormItem>


                            <FormItem {...formItemLayout} label="Class Available Until">
                                {getFieldDecorator('availableDate', {
                                    initialValue: this.formVariables.AvailableDate,
                                })(
                                    <DatePicker
                                        format="MM-DD-YYYY"
                                        placeholder={['Available Until...']} />
                                )}
                            </FormItem>
                            {/* I removed commented out end date code from here since it is above on 10/19/2021 Elliot Thompson */}
                            <FormItem {...formItemLayout} label="Venue" >
                                {getFieldDecorator('venue', {
                                    initialValue: this.formVariables.Venue,
                                    rules: [{
                                        required: true, message: 'Please input venue!',
                                    }],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Venue URL" >
                                {getFieldDecorator('venueURL', {
                                    initialValue: this.formVariables.VenueURL,
                                    rules: [{
                                        required: false
                                    }],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Address" >
                                {getFieldDecorator('address', {
                                    initialValue: this.formVariables.Address,
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="City" >
                                {getFieldDecorator('city', {
                                    initialValue: this.formVariables.City,
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Cost">
                                {getFieldDecorator('cost', {
                                    initialValue: this.formVariables.Cost,
                                })(<InputNumber />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Payment URL">
                                {getFieldDecorator('paymentURL', {
                                    initialValue: this.formVariables.PaymentURL,
                                    rules: [{
                                        required: false
                                    }]
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Meeting URL">
                                {getFieldDecorator('meetingURL', {
                                    initialValue: this.formVariables.MeetingURL,
                                    rules: [{
                                        required: false
                                    }]
                                })(<Input />)}
                            </FormItem>
                            {(!this.state.HybridSelected && !(this.state.CRSelected && this.state.indef)) &&
                                <FormItem {...formItemLayout} label="Capacity" >
                                    {getFieldDecorator('capacity', {
                                        initialValue: this.formVariables.Capacity,
                                    })(<InputNumber min={1} />)}
                                </FormItem>
                            }
                            {this.state.HybridSelected &&
                                <FormItem {...formItemLayout} label="In-Person Capacity" >
                                    {getFieldDecorator('capacity', {
                                        initialValue: this.formVariables.Capacity,
                                        rules: [{
                                            required: true, message: 'Please input capacity!',
                                        }],
                                    })(<InputNumber min={1} />)}
                                </FormItem>
                            }
                            {this.state.HybridSelected &&
                                <FormItem
                                    label="Online Capacity"
                                    {...formItemLayout}>
                                    {getFieldDecorator('onlineCapacity', {
                                        initialValue: this.formVariables.OnlineCapacity,
                                        rules: [{ required: true, message: 'Please input online capacity!' }],
                                    })
                                        (<InputNumber min={1} />)
                                    }
                                </FormItem>}
                            {/*<FormItem {...formItemLayout} label="Waitlist Capacity" >
                            //    {getFieldDecorator('waitlist', {
                            //        initialValue: this.formVariables.Waitlist,
                            //        rules: [{
                            //            required: false, message: 'Please input a waitlist capacity!',
                            //        }],
                            //    })(<InputNumber />)}
                            </FormItem>*/}
                            <FormItem {...formItemLayout} label="Comments" >
                                {getFieldDecorator('comments', {
                                    initialValue: this.formVariables.Comments,
                                    rules: [{
                                        required: false
                                    }],
                                })(<textarea style={{ width: '650px', height: '90px' }} />)}
                            </FormItem>
                            {!this.props.updateFields && <FormItem {...tailFormItemLayout}>
                                <button type="submit" className="btn btn-default">Submit</button>
                                <button type="button" className="btn btn-default" onClick={() => { this.handleReset(); }} style={{ margin: 15 }}>Reset All</button>
                                <button type="submit" className="btn btn-default" onClick={event => (event.preventDefault(), window.location.href = '#/admin/admin')} >Main Menu</button>

                            </FormItem>}
                            {this.props.updateFields && <FormItem {...tailFormItemLayout}>
                                <button type="button" className="btn btn-default" onClick={() => { this.handleBack() }} >Back</button>
                                <button type="button" className="btn btn-default" style={{ margin: 5 }} onClick={(e) => { this.handleSubmit(e) }}>Update</button>
                            </FormItem>}

                        </Form>
                    </Spin>
                    : <Redirect to="/login" replace />
            }</div>
        );
    };

}

const WrappedAddClassesForm = Form.create()(AddClassForm);

export default WrappedAddClassesForm;



// WEBPACK FOOTER //
// ./src/Admin/AddClassForm.js